<template>
  <div id="addContainer" v-loading="loading" :element-loading-text="loadingTxt" element-loading-background="rgba(255,255,255,0.7)">
    <div v-if="active==='index'" class="formWarp" :class="{ 'formWarp--add': showType === 'add' }">
      <div v-if="showType === 'check'" class="progressIng">
        <div style="display: flex; align-items: center">
          <div class="taskName">
            {{ taskData.taskName }}
          </div>
          <el-tag style="margin-left: 5px; border-radius: 17px" :type="
            taskData.taskStatus == 0 ? 'info' : taskData.taskStatus == 1 ? 'success' : taskData.taskStatus == 2 ? '' : 'danger'">
            {{ taskData.taskStatusName }}
          </el-tag>
          <el-button style="margin-left: 10px" size="small" @click="updateSuspend">{{ taskData.isSuspend === 1 ? '启动' : '暂停' }}计划</el-button>
        </div>
        <div>
          <span class="createDate">创建时间：{{ taskData.createDate }}</span>
          <el-button type="primary" size="small" @click="openProgressFeedBackBox">
            进度反馈
          </el-button>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="baseInfo">
        <!-- 详情 -->
        <h4 v-if="checkType == 'check'" class="header-title">
          计划详情
        </h4>
        <div class="contentInfo">
          <el-form v-if="checkType == 'check'" ref="baseForm8" :inline="true" :model="baseForm"
            class="demo-form-inline baseForm" label-position="left" size="small">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="创建人" label-width="120px">
                  <el-input v-model="taskData.createUserName" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计划开始时间" label-width="120px">
                  <el-input v-model="baseForm.startDate" readonly value-format="yyyy-MM-dd" type="date">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计划结束时间" label-width="120px">
                  <el-input v-model="baseForm.endDate" readonly value-format="yyyy-MM-dd" type="date">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="工期" label-width="120px">
                  <el-input v-model="schedule" readonly style="width: 50%">
                    <template slot="append">
                      天
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计划类型" label-width="120px">
                  <el-input v-model="baseForm.taskType.cnName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="标准工期" label-width="120px">
                  <el-input v-model="baseForm.standardSchedule" style="width: 50%" placeholder="请输入标准工期" readonly>
                    <template slot="append">
                      天
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="专业" label-width="120px">
                  <el-input v-model="baseForm.specIds" type="textarea" autosize :title="baseForm.specIds" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label-width="120px" :label="$titles.child+'分组'">
                  <el-input v-model="baseForm.childIds" readonly type="textarea" autosize />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="责任岗位" label-width="120px">
                  <el-input v-model="baseForm.roleIds" readonly type="textarea" autosize />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="责任人" label-width="120px">
                  <el-input v-model="baseForm.userName" type="textarea" autosize readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否关键计划" label-width="120px">
                  <el-input v-model="baseForm.coreTask" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="里程碑" label-width="130px">
                  <el-input v-model="baseForm.isMilestone" readonly />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="关联流程" label-width="120px">
                  <el-input v-model="baseForm.flowDefinitionNames" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="流程计算进度" label-width="120px">
                  <el-input v-model="baseForm.isFlowSchedule" readonly />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- 添加和编辑 -->
        <h4 v-if="checkType != 'check'" class="header-title" style="font-weight: bold">
          基本信息
        </h4>
        <el-form v-if="checkType != 'check'" ref="baseForm" :model="baseForm" :rules="baseFormRules"
          class="demo-form-inline baseForm" size="small" :disabled="showType === 'check'" label-position="left">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="名称" prop="taskName" label-width="110px">
                <el-input ref="taskName" v-model="baseForm.taskName" maxlength="40" show-word-limit placeholder="请输入计划名称"></el-input>
                <span slot="error" class="item-error">
                  <span>请输入计划名称, 长度在 2 到 40 个字符</span>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="计划开始时间" prop="startDate" label-width="110px">
                <el-date-picker :key="startDateKey" ref="startDateRef" v-model="baseForm.startDate"
                  :picker-options="startDatePickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :disabled="checkType == 'edit'&&taskPre">
                </el-date-picker>
                <span slot="error" class="item-error">
                  <span>请选择计划开始时间</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="计划结束时间" prop="endDate" label-width="110px">
                <el-date-picker :key="endDateKey" ref="endDateRef" v-model="baseForm.endDate"
                  :picker-options="endDatePickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
                </el-date-picker>
                <span slot="error" class="item-error">
                  <span>请选择计划结束时间</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工期" prop="customer" label-width="110px">
                <el-input v-model="schedule" disabled placeholder="选择时间"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="计划类型" prop="customerManager" label-width="110px">
                <el-tree-select v-model="baseForm.taskType" :options="taskTypeTreeData" :props="taskTypeTreeProps"
                  @change="taskTypeChange" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="标准工期" prop="standardSchedule" label-width="110px">
                <el-input v-model="baseForm.standardSchedule" placeholder="请输入标准工期" maxlength="5">
                  <template slot="append">
                    天
                  </template>
                </el-input>
                <span slot="error" class="item-error">
                  <span>必须输入正整数或者保留一位小数</span>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="专业" prop="specIds" label-width="110px">
                <el-select v-model="baseForm.specIds" style="max-height: 150px; overflow: auto" filterable multiple
                  placeholder="请选择" @change="filterRoleList($event, 'spec')" @remove-tag="filterRoleList()">
                  <el-option v-for="(item, index) in specList" :key="index" :label="item.specName" :value="item.specId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item :label="`${$titles.child}分组`" prop="childIds" label-width="110px">
                <el-select v-model="baseForm.childIds" filterable multiple placeholder="请选择" clearable
                  @change="filterUserList('child')" @remove-tag="filterUserList('child')">
                  <el-option v-for="(item,index) in childList" :key="index" :label="item.childName"
                    :value="item.childName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="责任岗位" prop="roleIds" label-width="110px">
                <el-select v-model="baseForm.roleIds" style="max-height: 150px; overflow: auto" filterable multiple
                  placeholder="请选择" @change="filterUserList('role')" @remove-tag="filterUserList('role')">
                  <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.roleId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="责任人" prop="taskUserName" label-width="110px">
                <el-select v-model="userInfoList" style="max-height: 150px; overflow: auto" value-key="userId" multiple
                  filterable placeholder="请选择">
                  <el-option v-for="(item, index) in userInfoList2" :key="index" :label="item.userName" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="里程碑" prop="isMilestone" label-width="110px" class="isMilestoneStyle">
                <el-radio-group v-model="baseForm.isMilestone">
                  <el-radio :label="shi">是</el-radio>
                  <el-radio :label="fou">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联流程" prop="flowDefinitionIdList" label-width="110px">
                <el-select v-model="baseForm.flowDefinitionIdList" style="max-height: 150px; overflow: auto"
                  value-key="flowDefinitionId" filterable placeholder="请选择">
                  <el-option v-for="(item, index) in processList" :key="index" :label="item.flowName"
                    :value="item.flowDefinitionId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="流程计算进度" prop="isFlowSchedule" label-width="110px">
                <el-radio-group v-model="baseForm.isFlowSchedule">
                  <el-radio :label="shi">是</el-radio>
                  <el-radio :label="fou">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 计划指引 -->
      <el-card shadow="never">
        <div slot="header">
          <div class="headerBox">
            <span style="font-weight: bold">计划指引</span>
            <!-- 编辑计划指引 按钮 -->
            <el-button v-if="showType !== 'check' && isGuideEditShow" size="small" type="primary" plain @click="submitTaskGuideForm('edit')">编辑</el-button>
            <!-- 添加计划指引 按钮-->
            <el-button v-if="showType !== 'check' && !isGuideEditShow" size="small" type="primary" plain @click="submitTaskGuideForm('add')">添加</el-button>
          </div>
        </div>
        <!-- 添加和编辑时才有 -->
        <el-form v-if="showType !== 'check'" ref="taskGuideForm" :model="taskGuideForm" :rules="taskGuideRules"
          label-width="100px" class="demo-ruleForm" label-position="left"
          style=" height: 90%; overflow: auto; position: sticky; top: 0; background-color: #fff; " size="small">
          <el-row>
            <el-col>
              <el-form-item label="计划指引" prop="guide">
                <el-input v-model.trim="taskGuideForm.guide" maxlength="100" show-word-limit type="textarea" :rows="4"
                  placeholder="请输入计划指引">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="上传附件">
                <el-upload :action="action" :limit="5" :on-exceed="handleExceed" :on-success="taskFileOnSuccess" :on-remove="taskFileOnRemove"
                  :headers="headers" :file-list="fileKeysShow" style="width: 100%" class="addupload" multiple>
                  <el-button size="small" type="primary" plain icon="el-icon-upload2">
                    上传文件
                  </el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 计划指引列表 -->
        <el-collapse v-if="guideList && guideList.length > 0" v-model="guideActive" accordion
          @change="guideSelectChange">
          <el-collapse-item v-for="(item, index) in guideList" :key="index" :name="index">
            <template slot="title">
              <span :title="item.guide" style=" text-overflow: ellipsis; white-space: nowrap; overflow: hidden; ">
                {{ item.guide }}</span>
              <i v-if="showType !== 'check'" class="header-icon el-icon-close" @click.stop="removeGuide(index)"></i>
              <i v-if="showType !== 'check' && index !== 0" class="header-icon el-icon-top" @click.stop="up(index)"></i>
              <i v-if="showType !== 'check' && index !== guideList.length - 1" class="header-icon el-icon-bottom"
                @click.stop="down(index)"></i>
            </template>
            <el-table v-if="item.fileKeys.length > 0" :data="item.fileKeys" border>
              <el-table-column label="名称" prop="realName"> </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <span>
                    <i class="el-icon-download" title="下载" style="color: var(--theme-color)"
                      @click="uploadFile(scope.row)" />
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <!-- 进度 编辑的时候才有 -->
      <div v-show="showType === 'check'" class="progressStatus"
        style="margin-bottom: 15px; display: flex; align-items: center">
        <span>进度：</span>
        <el-progress :text-inside="true" :stroke-width="20" :percentage="taskData.taskProgress" style="flex: 2">
        </el-progress>
      </div>
      <!-- 紧前计划 添加和编辑的时候才有-->
      <div class="frontTask">
        <el-row :gutter="0">
          <el-col :span="18">
            <div style=" display: flex; align-items: center; justify-content: flex-start; margin-bottom: 20px; ">
              <h4 style="margin: 0;margin-right:10px">
                紧前计划
              </h4>
              <el-button v-if="checkType != 'check'" size="small" type="primary" plain :disabled="showType === 'check'"
                @click="openPreTaskBox">
                <i class="el-icon-plus"></i>添加
              </el-button>
            </div>
          </el-col>
        </el-row>

        <el-form ref="preTaskForm" :inline="true" :model="preTaskForm" :rules="preTaskFormRules"
          class="demo-form-inline baseForm" label-position="top" :disabled="showType === 'check'" size="small">
          <el-row v-show=" preTaskForm.preTaskList.filter( (item) => item.relaStatus === '0' )[0]" :gutter="0">
            <el-col :span="18">
              <div style="margin-bottom: 15px">
                完成-开始：以下计划完成后，当前计划才能开始
              </div>
              <div class="content" style="max-height: 200px; overflow-y: auto">
                <div v-for="(item, index) in preTaskForm.preTaskList.filter( (item) => item.relaStatus === '0' )" :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                  <span style="color: #8daeed">
                    <span style="margin-right: 10px">
                      {{ getWBSCode(item, 1) }}
                    </span>
                    {{ item.preTaskName || item.taskName }}
                  </span>
                  <span>
                    <i v-if="showType !== 'check'" class="el-icon-close" style="color: red; cursor: pointer" @click="delPreTask(item, index)"></i>
                  </span>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row v-show="!preTaskForm.preTaskList[0]" :gutter="0">
            <el-col :span="24">
              <div style="text-align: center">
                <img :src="zanwu" alt="" style="width:100px;height:100px" />
                <p style="font-size:14px;color:#000;margin-top:10px">
                  暂无数据
                </p>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 紧后计划 编辑和详情的时候有-->
      <div v-show="showType !== 'add'" class="rearTask">
        <h4>紧后计划</h4>
        <el-form ref="afterTaskForm" :inline="true" :model="afterTaskForm" :rules="afterTaskFormRules"
          class="demo-form-inline baseForm" label-position="top" :disabled="showType === 'check'" size="small">
          <el-row v-show=" afterTaskForm.afterTaskList.filter((item) => item.relaStatus === '0')[0]" :gutter="0">
            <el-col :span="18">
              <div style="margin-bottom: 15px">
                完成-开始：当前计划结束后，以下计划才能开始
              </div>
              <div class="content" style="max-height: 200px; overflow-y: auto">
                <div v-for="(item, index) in afterTaskForm.afterTaskList.filter( (item) => item.relaStatus === '0' )" :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                  <span style="color: #8daeed">
                    <span style="margin-right: 10px">
                      {{ getWBSCode(item, 2) }}
                    </span>
                    {{ item.taskName }}</span>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row v-show="!afterTaskForm.afterTaskList[0]" :gutter="0">
            <el-col :span="24">
              <div style="text-align: center">
                <img :src="zanwu" alt="" style="width:100px;height:100px" />
                <p style="font-size:14px;color:#000;margin-top:10px">
                  暂无数据
                </p>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 评论区 详情才有-->
      <div v-if="showType === 'check'" class="operationInfo">
        <el-tabs v-model="activeName" @tab-click="tabClick">
          <el-tab-pane label="计划流程" name="taskProcess">
            <el-row :gutter="0">
              <el-col :span="24">
                <el-table :data="taskProcessList" border max-height="500px" style="width: 100%">
                  <el-table-column type="index" label="编号" width="60" />
                  <el-table-column label="状态" prop="status" width="80px" align="center">
                    <template slot-scope="scope">
                      <flowStatus :status="scope.row.status" />
                    </template>
                  </el-table-column>
                  <el-table-column label="流程类型" prop="flowType" min-width="80px" />
                  <el-table-column label="标题" prop="title" min-width="150px">
                    <template #default="{ row }">
                      <el-link type="primary" @click="clickLook(row,1)">
                        <span class="tabLinkSpan" :title="row.title">{{ row.title }}</span>
                      </el-link>
                    </template>
                  </el-table-column>
                  <el-table-column label="内容" prop="content" min-width="200px" width="*" show-overflow-tooltip />
                  <el-table-column label="申请人" prop="flowInstanceOwnerName" min-width="120px" show-overflow-tooltip />
                  <el-table-column label="开始时间" prop="flowInstanceStartTime" min-width="120px" show-overflow-tooltip />
                  <el-table-column label="当前审批人" prop="currentNodeAssigneeName" min-width="120px" show-overflow-tooltip />
                  <el-table-column label="上个审批节点" prop="lastNodeName" min-width="100px" show-overflow-tooltip />
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <div style="display: inline-block;margin-left:10px">
                        <el-dropdown trigger="click" @command="handleCommand" @click.native="clickMore(scope.row)">
                          <el-button type="text">
                            更多
                          </el-button>
                          <el-dropdown-menu slot="dropdown" class="header-new-drop">
                            <el-dropdown-item
                              v-for="(item,index) in moreOperate"
                              :key="index"
                              :command="beforeHandleCommand(item.key,scope.row)">
                              {{ item.name }}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination background :total="totalCount" :page-size="pageSize" :current-page="pageIndex"
                  :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev, pager, next, jumper"
                  style="text-align: end;" @size-change="handleSizeChange" @current-change="currentChange" />
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="评论区" name="comment">
            <el-row :gutter="0">
              <el-col :span="18">
                <div class="comment">
                  <el-input v-model="discussContent" maxlength="100" show-word-limit type="textarea" :rows="4"
                    placeholder="增加评论/处理意见">
                  </el-input>
                  <div style="margin-top: 15px; text-align: right">
                    <el-button size="small" type="primary" :disabled="!discussContent" @click="addComment">
                      发表评论
                    </el-button>
                  </div>
                </div>
                <div class="list" style="max-height: 500px; overflow-y: auto">
                  <div v-for="(item, index) in commentList" :key="index" class="item"
                    style="padding: 10px; border-bottom: 1px solid #eee">
                    <div style=" color: #8091a5; font-size: 14px; margin-bottom: 5px; ">
                      {{ item.createTime }} {{ item.createUserName }} 新增
                    </div>
                    <div>{{ item.discussContent }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="修改记录" name="updateLog">
            <el-row :gutter="0">
              <el-col :span="24">
                <el-table :data="updateLogList" border max-height="500px" style="width: 100%">
                  <el-table-column show-overflow-tooltip align="center" prop="taskName" label="计划名称">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="startDate" label="计划开始时间">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="endDate" label="计划结束时间">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="taskTypeName" label="计划类型">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="taskUserName" label="责任人">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="operUserName" label="修改人">
                  </el-table-column>
                  <el-table-column show-overflow-tooltip align="center" prop="operDate" label="修改时间" width="175">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="进度反馈" name="progressFeedback">
            <div style="max-height: 500px; overflow-y: auto">
              <div v-for="(item, index) in progressFeedBackList" :key="index" class="item"
                style="padding: 10px; border-bottom: 1px solid #eee">
                <div style="color: #8091a5; margin-bottom: 5px">
                  {{ item.createTime }} {{ item.createUserName }} 新增进度反馈
                </div>
                <div style="font-size: 14px">
                  <div>进度：{{ item.taskProgress }}%</div>
                  <div v-if="item.remark" style="padding: 5px 0">
                    备注:{{ item.remark }}
                  </div>
                  <div v-if="item.fileList.length">
                    <span>附件：</span>
                    <div style="display: inline-block; vertical-align: top">
                      <el-link v-for="(items, indexs) in item.fileList" :key="indexs" type="primary"
                        style="display: block" @click="dataPreview(items)">
                        {{ items.realName }}
                      </el-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 提交取消 只有添加和编辑的时候有-->
    <div v-if="showType !== 'check'&&active==='index'" class="btns" :class="{ 'btns--add': showType === 'add' }">
      <el-button style="width: 95px" size="small" type="primary" :loading="submitLoading" @click="submit">
        提交
      </el-button>
      <el-button style="width: 95px" size="small" @click="cancel">
        取消
      </el-button>
    </div>
    <!-- 取消 只有详情的时候有 -->
    <div v-if="showType == 'check'&&active==='index'" class="btns" :class="{ 'btns--add': showType === 'add' }">
      <el-button style="width: 95px" size="small" type="primary" @click="cancel">
        返回
      </el-button>
    </div>
    <workbenchApprovalVue v-if="active==='workbenchApprovalVue'" :close-approve="closeApprove">
    </workbenchApprovalVue>
    <workbenchFlowDetailVue v-if="active==='workbenchFlowDetailVue'" :close-flow-detail="closeFlowDetail"
      :show-flow-again="showFlowAgain"></workbenchFlowDetailVue>
    <el-dialog v-dialogDrag class="taskLabel" title="添加专业" :visible.sync="isShowTaskLabel" width="600px" top="17vh"
      :close-on-click-modal="false" :close-on-press-escape="false" @close="taskLabelClose">
      <div class="content">
        <el-form ref="form1" :inline="true" :model="taskLabelForm" :rules="taskLabelFormRules" label-position="top"
          size="small" @submit.native.prevent>
          <el-form-item label="专业名称" prop="taskLabelName" style="width: 100%; display: inline-block; margin-right: 0px">
            <el-input v-model="taskLabelForm.taskLabelName" maxlength="10"></el-input>
          </el-form-item>
        </el-form>
        <div class="taskLabelList">
          <div v-for="(item, index) in showTaskLabelList" :key="index" class="item" @click="toggleTaskLabel(item)">
            <span style="color: #538be6; width: 180px">{{
              item.labelName
            }}</span>
            <el-tag style=" border-radius: 50%; height: 30px; width: 30px; border: none; " :color="item.labelColor">
            </el-tag>
            <span style="width: 60px">
              <i v-show="
                baseForm.taskLabelList.some(
                  (Item) => Item.labelId === item.labelId
                )
              " class="el-icon-check"></i>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag class="preTask" title="紧前计划" :visible.sync="isShowPreTaskBox" width="30%" append-to-body
      top="17vh" :close-on-click-modal="false" :close-on-press-escape="false" @close="preTaskClose">
      <div class="preTask_content">
        <div class="top">
          <span>选择紧前计划链接关系</span>
          <div>
            <el-radio v-model="preTaskRadio" label="0">
              完成-开始（所关联紧前计划完成后，当前计划才能开始）
            </el-radio>
          </div>
        </div>
        <div class="bottom">
          <span>选择紧前计划</span>
          <div class="tree">
            <el-input v-model="preTaskFilterText" size="small" style="width: 100%; margin-bottom: 10px"
              placeholder="输入关键字进行过滤" clearable>
            </el-input>
            <div class="treeWarp">
              <el-tree ref="preTaskTree" check-strictly default-expand-all :filter-node-method="preTaskFilterNode"
                :data="treeTask" node-key="taskId" :props="defaultProps" show-checkbox style="background: #f6f9fe"
                @check="handlePreTaskCheckChange">
                <span slot-scope="{ node, data }" class="custom-tree-node">
                  <span><span style="margin-right: 10px">{{
                    getWBSCode(data, 2)
                  }}</span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="preTaskClose">取 消</el-button>
        <el-button type="primary" size="small" @click="addPreTask">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag class="progressFeedBack" title="进度反馈" :visible.sync="isShowProgressFeedBackBox" width="30%"
      top="17vh" :close-on-click-modal="false" :close-on-press-escape="false" @close="progressFeedBackClose">
      <div class="content">
        <el-form ref="taskProgressform" :model="progressFeedForm" label-position="top" :rules="taskProgressrules"
          size="small" @submit.native.prevent>
          <el-form-item label="进度" prop="taskProgress">
            <el-input v-model.number="progressFeedForm.taskProgress" style="width: 300px" maxlength="3" show-word-limit size="small">
            </el-input>
            %
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="progressFeedForm.remark" maxlength="100" show-word-limit type="textarea" :rows="4"
              placeholder="增加评论/处理意见">
            </el-input>
          </el-form-item>
          <el-form-item label="上传附件">
            <el-upload :disabled="disabledone2" class="dataUpload" :action="action" :limit="5"
              :on-exceed="handleExceed"
              :on-success="dataOnSuccess" :on-remove="dataOnRemove" :on-preview="dataPreview"
              :before-upload="dataprogress2" :headers="headers" :file-list="progressFeedForm.fileList" multiple>
              <el-button :disabled="disabledone2" size="small" type="primary" plain icon="el-icon-upload2">
                上传文件
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="progressFeedBackClose">取 消</el-button>
        <el-button type="primary" :disabled="!progressFeedForm.taskProgress" size="small" :loading="taskProgressLoading"
          @click="addProgressFeedBack('taskProgressform')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/CommonDP/service/progress-service";
import proBackupsRequest from "@/CommonDP/service/downloadFile-service.js";
import elTreeSelect from "@/CommonDP/components/elTreeSelect";
import { uploadDataUrl, getToken, downloadFileShowPrompt } from "@/CommonDP/utils";
import { mapState } from "vuex";
import globalParams from "@/CommonDP/utils/globalParams";
import flowStatus from "@/CommonDP/components/flowComponents/flowStatus";
import workbenchFlowDetailVue from "@/CommonDP/pages/components/launchFlow/workbenchFlowDetail.vue";
import workbenchApprovalVue from "@/CommonDP/pages/components/launchFlow/workbenchApproval.vue";

export default {
  name: "TaskDetail",
  components: { elTreeSelect, flowStatus, workbenchFlowDetailVue, workbenchApprovalVue },
  props: {
    showType: {
      type: String,
      required: true
    }, // check是详情 add是添加  edit是编辑
    task: {
      type: String,
      required: true
    }
  },
  data() {
    const standardSchedules = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback();
      } else if (!/^[+]?\d+(\.\d)?$/.test(value)) {
        callback(new Error("必须输入正整数或者保留一位小数"));
      } else {
        callback();
      }
    };
    const taskProgresss = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback();
      } else if (/^(-[1-9][0-9]*)$/.test(value)) {
        callback(new Error("进度不能为负数"));
      } else if (value > 100) {
        callback(new Error("进度必须小于100%"));
      } else {
        callback();
      }
    };
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      treeTask: [],
      isShowTaskLabel: false,
      isShowPreTaskBox: false,
      isShowProgressFeedBackBox: false,
      preTaskRadio: "0",
      preTaskFilterText: "",
      preTaskChecks: [],
      defaultProps: {
        children: "childList",
        label: "taskName"
      },
      activeName: "taskProcess",
      discussContent: "",
      taskProcessList: [], // 计划流程
      commentList: [], // 所有评论
      updateLogList: [], // 修改记录
      progressFeedBackList: [], // 反馈记录
      loading: false,
      loadingTxt: "",
      submitLoading: false,
      action: "",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      userInfoList: [], // 所有人员
      userInfoList2: [], // 所有人员下拉数据
      taskType: [], // 计划类型
      taskLabelList: [], // 所有专业
      showTaskLabelList: [], // 过滤的专业
      baseForm: {
        prjId: "",
        parentId: "",
        taskName: "", // 计划名称
        isMilestone: 0,
        startDate: "", // 计划开始时间
        endDate: "", // 计划结束时间
        schedule: "", // 工期
        realEndDate: "", // 实际完成时间
        standardSchedule: "", // 标准工期
        taskType: {}, // 计划类型
        taskUserList: [], // 责任人
        taskLabelList: [], // 专业
        fileList: [], // 附件列表
        taskUserName: "",
        prjStageChildPlanGroup: {
          prjStageChildPlanGroupID: "",
          prjStageChildPlanGroupName: ""
        }, // 子项分组管理
        guideList: [],
        flowDefinitionIdList: '', // 关联流程
        isFlowSchedule: 0 // 流程计算进度
      },
      preTaskForm: {
        preTaskList: [] // 紧前计划
      },
      afterTaskForm: {
        afterTaskList: [] // 紧后计划
      },
      taskLabelForm: {
        taskLabelName: "",
        taskLabelColour: "#63b4f3"
      },
      progressFeedForm: {
        taskProgress: "",
        remark: "",
        fileList: []
      },
      baseFormRules: {
        taskName: [
          {
            required: true,
            message: "请输入计划名称",
            trigger: "blur"
          },
          {
            min: 2,
            max: 40,
            message: "长度在 2 到 40 个字符",
            trigger: "blur"
          }
        ],
        startDate: [
          {
            required: true,
            message: "请选择计划开始时间",
            trigger: "change"
          }
        ],
        endDate: [
          {
            required: true,
            message: "请选择计划结束时间",
            trigger: "change"
          }
        ],
        standardSchedule: [{ trigger: "blur", validator: standardSchedules }]
        // taskUserList: [
        //   {
        //     required: true,
        //     message: "请选择责任人",
        //     trigger: "change"
        //   }
        // ],
        // taskLabelList: [
        //   {
        //     required: true,
        //     message: "请选择专业",
        //     trigger: "change"
        //   }
        // ]
      },
      preTaskFormRules: {},
      afterTaskFormRules: {},
      taskLabelFormRules: {
        taskLabelName: [
          {
            required: true,
            message: "请输入专业名称",
            trigger: "blur"
          }
        ]
      },
      colors: ["#63b4f3", "#a457b3", "#e9726e", "#fbb165", "#abd780", "#a6a6a6"],
      taskProgressrules: {
        taskProgress: [
          {
            type: "number",
            message: "进度必须为数字值"
          },
          {
            trigger: "blur",
            validator: taskProgresss
          }
        ]
      },
      submitStatus: "",
      taskData: {},
      taskId: "", // 提交成功后返回得id 用于跳转详情页面
      queryTaskId: "",
      errorInfo: {},
      type: "",
      setParentDisabledArr: new Set(),
      startDatePickerOptions: {},
      startDateKey: 0,
      endDatePickerOptions: {},
      endDateKey: 0,
      disabledone: false,
      disabledone2: false,
      taskProgressLoading: false,

      taskTypeTreeData: [],
      taskTypeTreeProps: {
        parent: "pid", // 父级唯一标识
        value: "id", // 唯一标识
        label: "cnName", // 专业显示
        children: "childNode" // 子级
      },
      checkType: "", // check是编辑 !check是添加
      childItemGroupList: [],

      taskGuideVisible: false,
      fileKeysShow: [],
      taskGuideForm: {
        guide: "",
        fileKeys: []
      },
      guideList: [],
      taskGuideRules: {},
      enableBindToFlow: true,
      specList: [],
      processList: [],
      roleList: [],
      childList: [],
      curTaskUserList: [],
      childPlanName: "",
      guideActive: null,
      processOptions: {
        emitPath: false,
        label: "flowDefinitionName",
        value: "flowDefinitionId",
        children: "flowDefinitionList",
        multiple: true
      },
      shi: 1,
      fou: 0,
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      active: "",
      taskPre: false,
      moreOperate: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo,
      activeNames: state => state.enterprise.activeName
    }),
    childItemGroupListFiltered() {
      return this.childItemGroupList.filter((item) => item.State == 0);
    },
    schedule() {
      const startData = this.baseForm.startDate;
      const endData = this.baseForm.endDate;
      return this.sumSchedule(startData, endData);
    },
    isGuideEditShow() {
      if (this.guideActive === "" || this.guideActive === null) return false;
      return true;
    }
  },

  watch: {
    "baseForm.startDate"(newValue, oldValue) {
      this.endDateKey = new Date().getTime();
      if (!this.$refs.endDateRef) return null;
      if (newValue === null) {
        this.baseForm.startDate = "";
      }
      this.$refs.endDateRef.pickerOptions.disabledDate = (time) => {
        return new Date(this.baseForm.startDate).getTime() > time.getTime() + 8.64e7;
      };
    },

    "baseForm.endDate"(newValue, oldValue) {
      this.startDateKey = new Date().getTime();
      if (!this.$refs.startDateRef) return null;
      if (newValue === null) {
        this.baseForm.endDate = "";
      }
      this.$refs.startDateRef.pickerOptions.disabledDate = (time) => {
        return time.getTime() > new Date(this.baseForm.endDate).getTime();
      };
    },
    "baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupID"(newValue, oldValue) {
      const data = this.childItemGroupList.filter((item) => item.ID === newValue);
      if (data.length > 0) {
        this.baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupName = data[0].GroupName;
      }
    },

    "taskLabelForm.taskLabelName"(newValue, oldValue) {
      if (newValue) {
        this.showTaskLabelList = this.taskLabelList.filter((item) => item.labelName.includes(newValue));
      } else {
        this.showTaskLabelList = this.taskLabelList;
      }
    },

    preTaskFilterText(val) {
      this.$refs.preTaskTree.filter(val);
    },
    task() {
      const type = "";
      this.queryTaskId = this.task;
      this.checkType = this.showType;
      this.baseForm.isMilestone = 0;
      this.baseForm.isFlowSchedule = 0;
      this.setRouteName(this.showType, type);
      if (this.showType !== "add") {
        this.loadingTxt = "数据加载中...";
        this.loading = true;
        this.queryDetail();
      }
      this.getAllDic();
      this.action = uploadDataUrl();
    },
    active(val) {
      this.$store.dispatch("setActiveName", val);
    }
  },
  created() {
    this.active = this.activeNames || 'index';
    const type = "";
    this.queryTaskId = this.task;
    this.checkType = this.showType;
    this.baseForm.isMilestone = 0;
    this.baseForm.isFlowSchedule = 0;
    this.setRouteName(this.showType, type);
    if (this.showType !== "add") {
      this.loadingTxt = "数据加载中...";
      this.loading = true;
      this.queryDetail();
      this.queryProcessList();
    }
    this.getAllDic();
    this.action = uploadDataUrl();
    this.enableBindToFlow = globalParams.getFn("task.detail.bindToFlow", null, true);
  },

  methods: {
    // 清空初始数据
    qinkong() {
      if (this.showType === "add") {
        this.$nextTick(() => {
          this.$refs.taskName.focus();
        });
      }
      this.guideActive = null;
      this.queryProcessList();
      this.$refs.baseForm.resetFields();
      this.baseForm.prjId = "";
      this.baseForm.parentId = "";
      this.baseForm.taskName = "";
      this.baseForm.isMilestone = 0;
      this.baseForm.startDate = "";
      this.baseForm.endDate = "";
      this.baseForm.schedule = "";
      this.baseForm.realEndDate = "";
      this.baseForm.standardSchedule = "";
      this.baseForm.taskType = {};
      this.baseForm.taskUserList = [];
      this.baseForm.taskLabelList = [];
      this.baseForm.fileList = [];
      this.baseForm.taskUserName = "";
      this.baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupID = "";
      this.baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupName = "";
      this.baseForm.guideList = []; // 计划指引列表数据 传后台
      this.baseForm.specIds = []; // 专业
      this.baseForm.childIds = []; // 子项
      this.baseForm.roleIds = []; // 责任岗位
      this.userInfoList = []; // 责任人
      this.userInfoList2 = []; // 责任人下拉数据
      this.baseForm.flowDefinitionIdList = ''; // 关联流程下拉数据
      this.taskGuideForm.guide = ""; // 计划指引输入框
      this.guideList = []; // 计划指引列表数据 保存展示
      this.taskGuideForm.fileKeys = []; // 计划指引文件
      this.fileKeysShow = []; // 计划指引文件
      this.preTaskForm.preTaskList = []; // 紧前计划
      this.afterTaskForm.afterTaskList = []; // 紧前计划
      this.baseForm.isFlowSchedule = 0;
    },
    // 计划指引 上移
    up(index) {
      if (index === 0) {
        return;
      }
      // 在上一项插入该项
      this.guideList.splice(index - 1, 0, this.guideList[index]);
      // 删除后一项
      this.guideList.splice(index + 1, 1);
      this.baseForm.guideList = JSON.parse(JSON.stringify(this.guideList));
    },
    // 计划指引 下移
    down(index) {
      if (index === this.guideList.length - 1) {
        return;
      }
      // 在下一项插入该项
      this.guideList.splice(index + 2, 0, this.guideList[index]);
      // 删除前一项
      this.guideList.splice(index, 1);
      this.baseForm.guideList = JSON.parse(JSON.stringify(this.guideList));
    },
    filterRoleList() {
      // 可以查询岗位和人员
      this.baseForm.roleIds = [];
      this.roleList = [];
      this.$forceUpdate();
      request.taskpackageroleListSpecChange(this.baseForm.specIds).then((res) => {
        if (res.result === "0") {
          this.roleList = res.data;
          this.filterUserList("add");
        }
      });
    },
    filterRoleListEdit() {
      // 可以查询岗位和人员
      this.baseForm.roleIds = [];
      this.roleList = [];
      this.baseForm.specIds = this.taskData.specRoleUserObject.spec ? this.taskData.specRoleUserObject.spec.map((item) => item.specId) : "";
      request.taskpackageroleListSpecChange(this.baseForm.specIds).then((res) => {
        if (res.result === "0") {
          this.roleList = res.data;
          this.baseForm.roleIds = this.taskData.specRoleUserObject.role ? this.taskData.specRoleUserObject.role.map((item) => item.roleId) : "";
          this.filterUserList("query");
        }
      });
    },
    // 责任人
    filterUserList(show) {
      const type = "0"; // type=0  是查下拉框字典。 type=1  是查实际选择的人
      const { prjId } = this.prjInfo;
      const planTaskId = this.queryTaskId;
      const specIds = this.baseForm.specIds.join(",");
      const roleIds = this.baseForm.roleIds.join(",");
      const childIds = this.baseForm.childIds.join(",");
      const specChildGroupIds = this.baseForm.prjStageChildPlanGroup.prjStageChildPlanGroupID;
      // specId  专业ids  ,分割  选填
      // specChildGroupIds  专业子项分组ids  ,分割  选填
      // roleIds  角色ids  ,分割  选填
      // childIds  子项ids  ,分割  选填
      if (show === "query") {
        // 查询的时候
        request
          .filterUserList({
            prjId,
            planTaskId,
            roleIds,
            specChildGroupIds,
            specIds,
            childIds,
            type
          })
          .then((res) => {
            if (childIds || roleIds || specIds) {
              // this.userInfoList 查询的时候不走这个接口 走详情的接口
              this.userInfoList2 = this.deWeightThree(res.data);
            } else {
              this.userInfoList = [];
            }
          });
      } else {
        request
          .filterUserList({
            prjId,
            planTaskId,
            roleIds,
            childIds,
            specChildGroupIds,
            specIds,
            type
          })
          .then((res) => {
            if (childIds || roleIds || specIds) {
              // 选择的时候 为了联动 就把查到的数据 都赋值上
              this.userInfoList = this.deWeightThree(res.data);
              this.userInfoList2 = this.deWeightThree(res.data);
            } else {
              this.userInfoList = [];
              this.userInfoList2 = [];
            }
          });
      }
    },
    deWeightThree(arr) {
      const map = new Map();
      for (const item of arr) {
        if (!map.has(item.userId)) {
          map.set(item.userId, item);
        }
      }
      return [...map.values()];
    },

    guideSelectChange(index) {
      if (index === "") {
        this.taskGuideForm = { guide: "", fileKeys: [] };
        this.fileKeysShow = [];
      } else {
        this.taskGuideForm = JSON.parse(JSON.stringify(this.guideList[index]));
      }
    },

    taskTypeChange(data) {
      const { prjId } = this.prjInfo;
      request.queryAverageTaskTime({ prjId, taskTypeId: data.id }).then((res) => {
        if (res.result === "0") this.baseForm.standardSchedule = res.data;
      });
    },
    removeGuide(index) {
      this.guideList.splice(index, 1);
      this.baseForm.guideList.splice(index, 1);
    },
    // 计划指引 保存和修改 确定按钮
    submitTaskGuideForm(type) {
      this.$refs["taskGuideForm"].validate((valid) => {
        if (valid) {
          if (this.taskGuideForm.guide) {
            const guide = JSON.parse(JSON.stringify(this.taskGuideForm));
            if (type === "edit") {
              if (this.guideActive != null) {
                this.baseForm.guideList.splice(this.guideActive, 1, guide);
                this.guideList.splice(this.guideActive, 1, guide);
              } else {
                this.$message.warning("请先选择需要修改的指引！");
              }
            } else {
              this.baseForm.guideList.push(guide);
              this.guideList.push(guide);
            }
            this.taskGuideForm.guide = "";
            this.taskGuideForm.fileKeys = [];
            this.fileKeysShow = [];
            this.guideActive = null;
          } else {
            this.$message.warning("请输入计划指引");
          }
        }
      });
    },
    // 计划指引 移除文件
    taskFileOnRemove(file, fileList) {
      const index = this.taskGuideForm.fileKeys.findIndex((item) => item.fileKey === file.fileKey);
      this.taskGuideForm.fileKeys.splice(index, 1);
    },
    // 计划指引 文件上传成功
    taskFileOnSuccess(response, file) {
      if (response.result === "0" && response.data) {
        response.data.name = response.data.realName;
        this.taskGuideForm.fileKeys.push(response.data);
      } else {
        this.$message.warning(response.message);
      }
    },
    getWBSCode(task, type) {
      const gantt = this.$store.state.projectMg.gantt;
      if (!gantt) {
        return "";
      }
      if (type === 1) {
        return gantt.getWBSCode(gantt.getTask(task.preTaskId || task.taskId));
      }
      return gantt.getWBSCode(gantt.getTask(task.taskId));
    },
    // 初始化时调用
    getAllDic() {
      request
        .queryTaskTypeTree()
        .then((res) => {
          if (res.result === "0") {
            this.taskTypeTreeData = res.data.childNode || [];
          }
        })
        .catch((error) => {
          this.$message.warning(error.message || "查询计划失败");
        });
      this.querySpecRoleList();
      this.querychildItemGroupList();
    },
    queryProcessList() {
      request.queryPlanFlowDefinitionList(this.enterpriseId).then((res) => {
        if (res.result === "0") {
          this.processList = res.data.filter((item) => item.isEnable === 1);
        }
      });
    },
    querySpecRoleList() {
      const { prjId } = this.prjInfo;
      request.taskpackagespecList(prjId, this.enterpriseId).then((res) => {
        if (res.result === "0") {
          this.specList = res.data;
        }
      });
      request.queryTaskPackageChildList(prjId).then((res) => {
        if (res.result === "0") {
          this.childList = res.data;
        }
      });
    },
    querychildItemGroupList() {
      const { prjId } = this.prjInfo;
      request
        .queryChildItemGroupList(prjId)
        .then((res) => {
          this.childItemGroupList = res.data;
        })
        .catch((e) => {
          this.$message.warning(e.message || "查询" + this.$titles.child + "分组失败");
        });
    },
    queryTaskLabelList() {
      request
        .queryTaskLabelList()
        .then((res) => {
          if (res.result === "0") {
            this.taskLabelList = res.data;
            for (let i = 0; i < this.taskLabelList.length; i++) {
              this.taskLabelList[i].labelId = this.taskLabelList[i].labelID;
              this.taskLabelList[i].labelColour = this.taskLabelList[i].labelColor;
            }
            this.showTaskLabelList = res.data;
            for (let k = 0; k < this.showTaskLabelList.length; k++) {
              this.showTaskLabelList[k].labelId = this.taskLabelList[k].labelID;
              this.showTaskLabelList[k].labelColour = this.taskLabelList[k].labelColor;
            }
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "查询专业失败");
        });
    },

    queryTreeTask() {
      const { prjId } = this.prjInfo;
      const isCore = 0;
      request
        .queryPlanList({
          prjId,
          isCore,
          labelIds: [],
          enterpriseId: this.enterpriseId
        })
        .then((res) => {
          if (res.result === "0") {
            if (res.data.list) {
              for (var t = 0; t < res.data.list.length; t++) {
                this.$set(res.data.list[t], "disabled", false);
                if (this.preTaskForm.preTaskList) {
                  for (var a = 0; a < this.preTaskForm.preTaskList.length; a++) {
                    if (this.preTaskForm.preTaskList[a].preTaskId) {
                      // 已经有的
                      if (res.data.list[t].taskId === this.preTaskForm.preTaskList[a].preTaskId) {
                        this.$set(res.data.list[t], "disabled", true);
                      }
                    } else {
                      // 新添加的
                      if (res.data.list[t].taskId === this.preTaskForm.preTaskList[a].taskId) {
                        this.$set(res.data.list[t], "disabled", true);
                      }
                    }
                  }
                }
                if (this.afterTaskForm.afterTaskList) {
                  for (var v = 0; v < this.afterTaskForm.afterTaskList.length; v++) {
                    if (res.data.list[t].taskId === this.afterTaskForm.afterTaskList[v].taskId) {
                      this.$set(res.data.list[t], "disabled", true);
                    }
                  }
                }
              }
              this.treeTask = res.data.list;
              console.log("this.treeTask", this.treeTask);
              this.filterArray(this.treeTask, this.queryTaskId);
            }
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "查询计划树失败");
        });
    },
    filterArray(data, taskId) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].taskId === taskId) {
          data[i].disabled = true;
          this.filterArray(data, data[i].parentId);
        }
      }
      this.treeTask = this.filterArray1(data, "0");
    },

    filterArray1(data, parentId) {
      const tree = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === parentId) {
          const obj = data[i];
          temp = this.filterArray1(data, data[i].taskId);
          if (temp.length > 0) {
            obj.childList = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },

    setRouteName(showType, type) {
      let routeName;
      this.type = type;
      if (type) {
        routeName = type === "milestone" ? "新增里程碑" : "";
      } else {
        routeName = showType === "add" ? "计划" : showType === "edit" ? "编辑计划" : "计划详情";
      }
      this.$route.meta.routeName = routeName;
      this.$store.dispatch("updateNavArr");
    },

    taskLabelClose() {
      this.queryTaskLabelList();
      this.taskLabelForm.taskLabelName = "";
      this.taskLabelForm.taskLabelColour = "#63b4f3";
      this.isShowTaskLabel = false;
    },

    preTaskClose() {
      this.preTaskRadio = "0";
      this.preTaskFilterText = "";
      this.preTaskChecks = [];
      this.treeTask = [...this.treeTask];
      this.setParentDisabledArr = new Set();
      this.isShowPreTaskBox = false;
    },

    progressFeedBackClose() {
      this.progressFeedForm.taskProgress = "";
      this.progressFeedForm.remark = "";
      this.progressFeedForm.fileList = [];
      this.isShowProgressFeedBackBox = false;
    },

    handlePreTaskCheckChange(data, nodes) {
      this.preTaskChecks = nodes.checkedNodes;
    },

    toggleTaskLabel(Item) {
      const index = this.baseForm.taskLabelList.findIndex((item) => item.labelId === Item.labelId);
      if (index > -1) {
        this.baseForm.taskLabelList.splice(index, 1);
      } else {
        if (this.baseForm.taskLabelList.length < 5) {
          this.baseForm.taskLabelList.push(Item);
        } else {
          this.$message({
            duration: 1000,
            message: "最多能选择5个专业",
            type: "warning",
            showClose: true
          });
        }
      }
    },

    addTaskLabel(formName) {
      if (this.baseForm.taskLabelList.length < 5) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const labelName = this.taskLabelForm.taskLabelName;
            const labelColour = this.taskLabelForm.taskLabelColour;
            request
              .addTaskLabel({ labelName, labelColour })
              .then((res) => {
                if (res.result === "0") {
                  this.baseForm.taskLabelList.push(res.data);
                  this.queryTaskLabelList();
                  this.taskLabelClose();
                }
              })
              .catch((e) => {
                this.$message.warning(e.message || "添加失败");
              });
          } else {
            this.$message({
              duration: 1000,
              message: "请检查！有必填项未填写",
              type: "warning",
              showClose: true
            });
            return false;
          }
        });
      } else {
        this.$message({
          duration: 1000,
          message: "最多能选择5个专业",
          type: "warning",
          showClose: true
        });
      }
    },

    addPreTask() {
      this.preTaskChecks.forEach((item) => {
        const { taskId, taskName } = item;
        const obj = {
          relaStatus: this.preTaskRadio,
          taskId,
          taskName
        };
        if (!this.preTaskForm.preTaskList.some((Item) => Item.taskId === obj.taskId)) {
          this.preTaskForm.preTaskList.push(obj);
          this.setParentDisabledArr.add(obj.taskId);
        }
      });
      this.preTaskClose();
    },

    addProgressFeedBack(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.taskProgressLoading = true;
          const taskId = this.queryTaskId;
          const { taskProgress, remark, fileList } = this.progressFeedForm;
          request
            .addProgressFeedBack({ taskProgress, remark, fileList, taskId })
            .then((res) => {
              if (res.result === "0") {
                this.$message.success("添加成功");
                this.taskProgressLoading = false;
                this.taskData.taskProgress = this.progressFeedForm.taskProgress;
                this.queryProgressFeedBack();
                this.progressFeedBackClose();
              }
            })
            .catch((e) => {
              this.taskProgressLoading = false;
            });
        }
      });
    },

    //  编辑和查看详情时  查询计划的详情信息
    queryDetail() {
      const taskId = this.task;
      request
        .queryDetail(taskId)
        .then((res) => {
          if (res.result === "0") {
            this.taskData = res.data;
            if (this.showType === "edit") {
              this.filterRoleListEdit();
              this.queryTaskPre(taskId);
            } else {
              this.pageIndex = 1;
              this.queryTaskProcessList();
            }
            this.setArguments(res.data);
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.warning(error.message || "查询详情失败");
        });
    },
    async queryTaskPre(taskId) {
      const { data } = await request.queryTaskPre(taskId);
      this.taskPre = data;
    },
    // 添加和编辑时的 提交按钮
    submit() {
      const refFormArr = ["baseForm", "preTaskForm", "afterTaskForm"];
      const flagArr = [];
      refFormArr.forEach((item) => {
        this.$refs[item].validate((valid) => flagArr.push(valid));
      });
      if (flagArr.every((item) => item === true)) {
        if (this.taskGuideForm.guide && !this.isGuideEditShow) {
          this.submitTaskGuideForm('add');
        }
        this.submitLoading = true;
        const data = this.getArguments();
        const requestType = this.showType === "add" ? "addPlan" : "editPlan";
        request[requestType](data)
          .then((res) => {
            if (res.result === "0") {
              this.submitLoading = false;
              this.taskId = this.showType === "add" ? res.data?.taskId : res.data;
              this.submitStatus = "succeed";
              if (this.showType === "add") {
                const messageType = res.data?.message ? "当前计划关联有紧前计划，开始时间和结束时间将跟随紧前计划的结束时间而改变" : "提交成功";
                this.$message.success(`${messageType}`);
                this.$emit("dialogClose", true);
              } else {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$router.push({ name: "taskList" });
              }
            }
          })
          .catch((error) => {
            this.errorInfo = error;
            this.submitLoading = false;
            this.submitStatus = "error";
            this.$message.warning(error.message || "添加失败");
          });
      } else {
        this.submitLoading = false;
        this.submitStatus = "error";
      }
    },

    // 添加和编辑时 设置一下 传给后台的数据
    getArguments() {
      const { baseForm, preTaskForm, afterTaskForm, queryTaskId } = this;
      const { prjId } = this.prjInfo;
      if (!this.baseForm.standardSchedule) {
        this.baseForm.standardSchedule = 0;
      }
      const {
        parentId,
        taskId,
        taskName, // 计划名称
        startDate, // 计划开始时间
        endDate, // 计划结束时间
        isMilestone, // 是否里程碑
        realEndDate,
        standardSchedule, // 标准工期
        taskType, // 计划类型
        taskLabelList, // 专业
        guideList, // 计划指引
        fileList, // 附件列表
        specIds,
        roleIds,
        childIds,
        prjStageChildPlanGroup: { prjStageChildPlanGroupID, prjStageChildPlanGroupName },
        isFlowSchedule
      } = baseForm;
      const preTaskList = [];
      for (var i = 0; i < preTaskForm.preTaskList.length; i++) {
        // 已经有紧前计划
        if (preTaskForm.preTaskList[i].preTaskName) {
          var ddd = {
            taskId: preTaskForm.preTaskList[i].preTaskId,
            taskName: preTaskForm.preTaskList[i].preTaskName,
            relaStatus: preTaskForm.preTaskList[i].relaStatus
          };
        } else {
          // 没有紧前计划 或者 新添加时
          var ddd = {
            taskId: preTaskForm.preTaskList[i].taskId,
            taskName: preTaskForm.preTaskList[i].taskName,
            relaStatus: preTaskForm.preTaskList[i].relaStatus
          };
        }

        preTaskList.push(ddd);
      }
      const { afterTaskList } = afterTaskForm;
      const users = this.userInfoList.map((item) => ({
        taskUserId: item.userId,
        taskUserName: item.userName
      }));

      // 添加的时候
      const specRoleUserObject = {
        spec: specIds.join(","),
        role: roleIds.join(","),
        child: childIds.join(","),
        user: this.userInfoList.map((item) => item.userId).join(",")
      };
      const flowDefinitionIdList = [];
      flowDefinitionIdList.push(baseForm.flowDefinitionIdList);
      return {
        prjId,
        parentId: this.showType === "add" ? queryTaskId : parentId,
        taskId,
        taskName, // 计划名称
        startDate, // 计划开始时间
        endDate, // 计划结束时间
        isMilestone,
        realEndDate,
        planSchedule: this.schedule,
        standardSchedule, // 标准工期
        taskType: taskType.id, // 计划类型
        taskTypeName: taskType.cnName, // 计划类型
        taskUserList: users, // 责任人,
        flowDefinitionIdList, // 流程
        taskLabelList, // 专业
        guideList: JSON.parse(JSON.stringify(guideList)), // 计划指引
        fileList, // 附件列表
        preTaskList, // 紧前计划
        afterTaskList, // 紧后计划
        prjStageChildPlanGroupID, // 子项分组GroupName
        prjStageChildPlanGroupName,
        specRoleUserObject,
        enterpriseId: this.enterpriseId,
        isFlowSchedule
      };
    },

    // 编辑和查看详情时 设置一下 计划的详情信息
    setArguments(resData) {
      console.log(resData);
      const {
        prjId,
        parentId,
        taskId,
        taskName,
        startDate,
        endDate,
        isMilestone,
        realEndDate,
        standardSchedule,
        taskType,
        taskTypeName,
        taskUserList,
        taskLabelList,
        guideList,
        fileList,
        preTaskList,
        afterTaskList,
        taskUserName,
        coreTask,
        specRoleUserObject,
        prjStageChildPlanGroupID,
        prjStageChildPlanGroupName,
        prjStageChildPlanGroupItems,
        flowDefinitionIdList,
        flowDefinitionNames,
        isFlowSchedule
      } = resData;
      this.baseForm.flowDefinitionIdList = flowDefinitionIdList[0];
      this.baseForm.flowDefinitionNames = flowDefinitionNames;
      this.baseForm.prjId = prjId;
      this.baseForm.parentId = parentId;
      this.baseForm.taskId = taskId;
      this.baseForm.taskName = taskName;
      this.baseForm.startDate = startDate;
      this.baseForm.endDate = endDate;
      this.baseForm.standardSchedule = standardSchedule;
      this.baseForm.isMilestone = isMilestone;
      this.baseForm.realEndDate = realEndDate;
      this.baseForm.taskUserName = taskUserName;

      this.baseForm.coreTask = coreTask ? "是" : "否";
      this.childPlanName = prjStageChildPlanGroupItems;
      this.baseForm.isFlowSchedule = isFlowSchedule;

      if (specRoleUserObject) {
        if (this.showType !== "check") {
          this.baseForm.specIds = specRoleUserObject.spec ? specRoleUserObject.spec.map((item) => item.specId) : [];
          this.baseForm.roleIds = specRoleUserObject.role ? specRoleUserObject.role.map((item) => item.roleId) : [];
          this.baseForm.childIds = specRoleUserObject.child ? specRoleUserObject.child.map((item) => item.childId) : [];
          this.userInfoList = specRoleUserObject.user ? specRoleUserObject.user : [];
          this.userInfoList2 = specRoleUserObject.user ? specRoleUserObject.user : [];
        } else {
          this.baseForm.isMilestone = isMilestone == 1 ? "是" : "否";
          this.baseForm.specIds = specRoleUserObject.spec ? specRoleUserObject.spec.map((item) => item.specName).join(",") : "";
          this.baseForm.roleIds = specRoleUserObject.role ? specRoleUserObject.role.map((item) => item.roleName).join(",") : "";
          this.baseForm.childIds = specRoleUserObject.child ? specRoleUserObject.child.map((item) => item.childName).join(",") : "";
          this.baseForm.userName = specRoleUserObject.user ? specRoleUserObject.user.map((item) => item.userName).join(",") : "";
          this.baseForm.isFlowSchedule = isFlowSchedule == 1 ? "是" : "否";
        }
      }
      this.baseForm.prjStageChildPlanGroup = {
        prjStageChildPlanGroupID,
        prjStageChildPlanGroupName
      };
      this.baseForm.taskType = {
        id: taskType,
        cnName: taskTypeName
      };
      this.baseForm.taskUserList = taskUserList.map((item) => ({
        userId: item.taskUserId,
        name: item.taskUserName
      }));
      this.baseForm.taskLabelList = taskLabelList;
      this.baseForm.guideList = JSON.parse(JSON.stringify(guideList));
      this.guideList = JSON.parse(JSON.stringify(guideList));
      this.setFileList(fileList);
      this.baseForm.fileList = fileList;
      this.preTaskForm.preTaskList = preTaskList;
      this.afterTaskForm.afterTaskList = afterTaskList;
      if (guideList.length === 1) {
        this.guideActive = 0;
      }
    },

    setFileList(annexList) {
      annexList.forEach((item) => {
        item.name = item.realName;
      });
    },

    cancel() {
      if (this.showType === "add") {
        this.$emit("dialogClose", false);
      } else {
        this.$router.push({ name: "taskList" });
      }
    },
    dataprogress() {
      this.disabledone = true;
    },
    dataprogress2() {
      this.disabledone2 = true;
    },
    dataOnSuccess(response, file, fileList) {
      if (response.result === "0" && response.data) {
        response.data.name = response.data.realName;
        if (this.isShowProgressFeedBackBox) {
          this.disabledone2 = false;
          this.progressFeedForm.fileList.push(response.data);
        } else {
          this.disabledone = false;
          this.baseForm.fileList.push(response.data);
        }
      }
    },

    dataOnRemove({ fileKey }) {
      const dataForm = this.isShowProgressFeedBackBox ? "progressFeedForm" : "baseForm";
      const index = this[dataForm].fileList.findIndex((item) => item.fileKey === fileKey);
      if (index > -1) {
        this[dataForm].fileList.splice(index, 1);
      }
    },

    dataPreview({ filePath, realName }) {
      if (this.showType === "check") {
        this.downFile(filePath, realName);
      }
    },

    downFile(filePath, realName) {
      proBackupsRequest.downloadFile(filePath).then((response) => {
        const fileName = realName;
        downloadFileShowPrompt(fileName, response);
      });
    },

    openPreTaskBox() {
      this.queryTreeTask();
      this.isShowPreTaskBox = true;
    },

    openProgressFeedBackBox() {
      var _this = this;
      try {
        _this.$refs["taskProgressform"].resetFields();
      } catch (e) {
        console.log();
      }
      _this.progressFeedForm.taskProgress = _this.taskData.taskProgress;
      _this.isShowProgressFeedBackBox = true;
    },

    /**
     * 更新计划是否启动状态
     * isSuspend 1启动 0暂停 number
     */
    async updateSuspend () {
      const { taskId, isSuspend } = this.taskData;
      const message = isSuspend === 1 ? '启动' : '暂停';
      try {
        await this.$confirm(`确定${message}计划吗?`, '提示');
        await request.updateSuspend({ taskId, isSuspend: isSuspend === 1 ? 0 : 1 });
        this.$message.success(`项目已${message}`);
        this.queryDetail();
      } catch (e) {
        console.log(e);
      }
    },
    delPreTask(item) {
      this.removeByValue(this.preTaskForm.preTaskList, "id", item.id);
    },
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] === value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    preTaskFilterNode(value, data) {
      if (!value) return true;
      return data.taskName.indexOf(value) !== -1;
    },

    addComment() {
      const taskId = this.queryTaskId;
      const discussContent = this.discussContent;
      request
        .addComment({ taskId, discussContent })
        .then((res) => {
          if (res.result === "0") {
            this.queryCommentList();
            this.discussContent = "";
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "添加评论失败");
        });
    },

    tabClick(tab, event) {
      if (tab.name === "taskProcess") {
        this.pageIndex = 1;
        this.queryTaskProcessList();
      } else if (tab.name === "comment") {
        this.queryCommentList();
      } else if (tab.name === "updateLog") {
        this.queryUpdateLog();
      } else {
        this.queryProgressFeedBack();
      }
    },
    queryTaskProcessList() {
      const { prjId } = this.prjInfo;
      const pageNum = this.pageIndex;
      const pageSize = this.pageSize;
      const params = {
        enterpriseId: this.enterpriseId,
        prjId,
        specId: "",
        taskId: this.queryTaskId
      };
      request
        .queryPrjAllPage(params, pageNum, pageSize)
        .then((res) => {
          if (res.result === "0") {
            this.taskProcessList = res.data;
            this.totalCount = res.totalCount;
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "查询计划流程失败");
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.queryTaskProcessList();
    },
    currentChange(val) {
      this.pageIndex = val;
      this.queryTaskProcessList(val);
    },
    queryCommentList() {
      request
        .queryComment(this.queryTaskId)
        .then((res) => {
          if (res.result === "0") {
            this.commentList = res.data;
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "查询评论列表失败");
        });
    },

    queryUpdateLog() {
      request
        .queryUpdateLog(this.queryTaskId)
        .then((res) => {
          if (res.result === "0") {
            this.updateLogList = res.data;
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "查询修改记录失败");
        });
    },

    queryProgressFeedBack() {
      request
        .queryProgressFeedBack(this.queryTaskId)
        .then((res) => {
          if (res.result === "0") {
            this.progressFeedBackList = res.data;
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "查询反馈记录失败");
        });
    },

    sumSchedule(date1, date2) {
      const sdate = new Date(date1);
      const now = new Date(date2);
      const days = now.getTime() - sdate.getTime() + 86400000;
      const day = Math.abs(parseInt(days / (1000 * 60 * 60 * 24)));
      return day || "";
    },
    clickLook(row, type) {
      const params = {
        ...row,
        title: '',
        flowInstanceNodeId: row.currentNodeId,
        flowDescribe: row.businessName,
        viewParam: "view",
        flowKey: row.businessType,
        readonly: true, // 用以替换 flowStatus
        flowStatus: true,
        application: true,
        showFlowAgainWithdraw: type
      };
      this.$store.dispatch("setRouterParams", params);
      this.showFlowDetail();
    },
    clickApprove(row) {
      const params = {
        ...row,
        title: '',
        flowInstanceNodeId: row.currentNodeId,
        flowDescribe: row.businessName,
        viewParam: "approve",
        flowKey: row.businessType,
        readonly: true, // 用以替换 flowStatus
        flowStatus: true,
        application: true,
        showFlowAgainWithdraw: 2 // 1是false 2是true
      };
      this.$store.dispatch("setRouterParams", params);
      this.showFlowDetail();
    },
    showFlowDetail() {
      this.active = "workbenchFlowDetailVue";
    },
    // 关闭流程详情
    closeFlowDetail() {
      this.active = "index";
      this.pageIndex = 1;
      this.queryTaskProcessList();
    },
    // 流程再发起
    showFlowAgain() {
      this.active = "workbenchApprovalVue";
    },
    // 关闭流程发起
    closeApprove() {
      this.active = "index";
      this.pageIndex = 1;
      this.queryTaskProcessList();
    },
    async clickMore(row) {
      this.moreOperate = [];
      const res = await request.queryFlowButton(row.flowInstanceId);
      this.moreOperate = Object.entries(res.data).map((item) => {
        return {
          name: this.nameFilter(item[0]),
          key: item[0],
          state: item[1]
        };
      });
      this.moreOperate = this.moreOperate.filter((item) => item.state === 1);
      if (this.moreOperate.length === 0) {
        this.moreOperate = [
          {
            name: '暂无更多操作',
            key: 'nodata',
            state: 1
          }
        ];
      }
    },
    nameFilter(val) {
      if (val === "isPass") {
        return '通过';
      } else if (val === "isReject") {
        return '驳回';
      } else if (val === "isWithdraw") {
        return '撤回';
      } else if (val === "isCountersign") {
        return '加签';
      } else if (val === "isTransmit") {
        return '转交';
      } else if (val === "isResubmit") {
        return '重新提交';
      }
    },
    beforeHandleCommand(val, row) {
      return { val: val, row: row };
    },
    handleCommand(command) {
      switch (command.val) {
        case "isPass":
          this.clickApprove(command.row);
          break;
        case "isReject":
          this.clickApprove(command.row);
          break;
        case "isWithdraw":
          this.clickLook(command.row, 2);
          break;
        case "isCountersign":
          this.clickApprove(command.row);
          break;
        case "isTransmit":
          this.clickApprove(command.row);
          break;
        case "isResubmit":
          this.clickLook(command.row, 2);
          break;
      }
    },
    uploadFile(row) {
      proBackupsRequest.downloadFile(row.filePath).then((response) => {
        const fileName = row.realName;
        downloadFileShowPrompt(fileName, response);
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制最多只能上传 5 个文件`);
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("updateIsShowNav", false);
    next();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("updateIsShowNav", true);
    });
  }
};
</script>
<style lang="scss" scoped>
.baseInfo {
  .el-cascader__tags {
    top: 40%;
  }
}
.el-select__tags-text {
  display: inline-block;
  max-width: 45px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-tag__close .el-icon-close {
  top: -5px;
}
</style>
<style lang="scss" scoped>
#addContainer {
  width: 100%;
  height: 100%;
  background-color: #eff1f6;
  /deep/ .el-card {
    margin-bottom: 15px;
    &__header{
      .headerBox{
        display: flex;
        align-items: baseline;
        justify-content: space-between;
      }
    }
    &__body {
      overflow: auto;
      min-height: 150px;
      max-height: 400px;

      .el-collapse-item__header.is-active {
        background-color: rgb(249, 250, 252);
      }
    }
  }
  .progressIng {
    width: 100%;
    height: 60px;
    background: #fff;
    border: 1px solid #eee;
    padding: 0 35px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .taskName {
      font-weight: bold;
    }

    .createDate {
      color: #8091a5;
      font-size: 14px;
      margin-right: 10px;
    }
  }
  .progressStatus {
    width: 100%;
    height: 50px;
    background: #fff;
    line-height: 50px;
    padding: 0 35px;
    box-sizing: border-box;
  }

  .formWarp {
    width: 100%;
    height:calc(100vh - 145px);
    overflow-y: auto;
    background-color: #eff1f6;
    box-sizing: border-box;
    .el-collapse-item {
      .header-icon {
        margin-left: 10px;
        visibility: hidden;
      }

      &:hover {
        .header-icon {
          margin-left: 10px;
          visibility: visible;
        }
      }
    }

    .baseInfo, .data, .operationInfo, .frontTask, .rearTask {
      width: 100%;
      margin-bottom: 15px;
      background-color: #fff;
      padding: 15px 15px;
      box-sizing: border-box;
      // 计划详情
      .contentInfo {
        /deep/ .el-input__inner {
          border: none;
        }

        /deep/ .el-input-group__append, .el-input-group__prepend {
          border: none;
          background-color: white;
        }

        /deep/ .el-form--inline .el-form-item__label {
          color: #8091a5;
        }

        /deep/ .el-textarea__inner {
          resize: none;
          border: none;
        }

        /deep/ .el-upload-list__item .el-icon-close {
          display: none !important;
        }

        /deep/ .el-upload-list__item-status-label {
          display: none !important;
        }

        /deep/ .el-upload {
          display: none;
        }

        .el-form--inline .el-form-item {
          display: flex;
        }

        /deep/ .el-upload-list__item.is-success.focusing .el-icon-close-tip {
          display: none !important;
        }
      }

      /deep/ .el-icon-circle-close {
        color: #C0C4CC;
      }

      /deep/ .el-form {
        padding-left: 15px;

        .el-form-item {
          width: 100%;
          margin-bottom:5px;

          .el-upload-list__item.is-success .el-upload-list__item-status-label {
            display: block;
          }

          .el-upload-list__item:hover {
            .el-icon-upload-success {
              display: none;
            }

            .el-icon-close {
              display: block;
            }
          }

          .el-form-item__content {
            // width: 100%;
            line-height:13px;

            .el-select {
              width: 100%;
            }

            .el-input {
              width: 100%;

              .el-input__inner {
                width: 100%;
              }
            }

            .el-upload__tip, .el-upload-list {
              padding-left: 15px;
            }
            .el-input--suffix {
              cursor: pointer;
              overflow: hidden;
            }
          }
          .item-error{
            display: inline-block;
            color: #F56C6C;
            font-size: 12px;
          }

        }

        .el-form-item__label {
          padding: 0;
          line-height:32px
        }

        .clientCode {
          .el-form-item__label {
            color: #faad14;
          }

          .el-input__inner {
            border: none;
            background-color: #fff;
          }
        }

        .dataUpload1 {
          .el-form-item__content {
            display: inline-block;
            width: 90%;
          }
        }
      }
      .isMilestoneStyle {
        /deep/ .el-form-item__content{
          line-height:29px !important;
        }
      }
    }
  }

  .formWarp--add {
    padding-bottom: 2px;
  }

  .btns {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    margin-left: -2px;
    position: absolute;
    bottom: 5px;
    z-index: 99;
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
  }

  .btns--add {
    position: sticky;
    width: calc(100% + 6px);
    margin-left: -2px;
  }
  .addupload {
    /deep/ .el-upload {
      text-align: initial;
    }
  }
}
// 添加专业 弹窗
.taskLabel {
  .el-dialog__header {
    background-color: #4d89f6;

    .el-dialog__title {
      color: #fff;
    }

    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 10px;
    height: 420px;
    box-sizing: border-box;
    background-color: #f1f2f6;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
      padding: 20px;
      box-sizing: border-box;

      .el-form {
        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          display: flex;
          align-items: center;
        }
      }

      .colors {
        display: flex;
        align-items: center;

        .item {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 20px;
          cursor: pointer;
        }

        .borderClass {
          width: 42px;
          height: 42px;
        }
      }

      .taskLabelList {
        width: 100%;
        height: 275px;
        padding: 10px 0;
        box-sizing: border-box;
        overflow-y: auto;

        .item {
          padding: 5px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          cursor: pointer;

          i {
            color: red;
            cursor: pointer;
          }
        }
      }
    }
  }
}
// 紧前计划 弹窗
.preTask {
  .el-dialog__header {
    background-color: #fff;

    .el-dialog__title {
      color: black;
    }

    .el-icon-close {
      color: black;
    }
  }

  .el-dialog__body {
    padding: 10px;
    height: 420px;
    box-sizing: border-box;
    background-color: #f1f2f6;

    .preTask_content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
      box-sizing: border-box;

      .top {
        width: 100%;
        line-height: 25px;
      }

      .bottom {
        width: 100%;
        height: calc(100% - 100px);

        .tree {
          margin-top: 10px;
          height: calc(100% - 29px);
          background: #f6f9fe;
          padding: 15px;
          box-sizing: border-box;
          border: 1px solid rgb(217, 230, 253);
          background: rgb(246, 249, 254);

          .treeWarp {
            overflow-y: auto;
            height: calc(100% - 47px);
            background: #f6f9fe;

            .el-tree {
              background: #f6f9fe;

              .el-tree-node {
                padding-top: 5px;

                .el-tree-node__content {
                  border-bottom: 1px solid #d9e0ea;
                  color: #538be6;
                }
              }
            }
          }
        }
      }
    }
  }
}
// 进度反馈 弹窗
.progressFeedBack {
  .el-dialog__header {
    background-color: #fff;

    .el-dialog__title {
      color: black;
    }

    .el-icon-close {
      color: black;
    }
  }

  .el-dialog__body {
    padding: 10px;
    height: 420px;
    box-sizing: border-box;
    background-color: #fff;
    border-top: 1px solid #2e5bff1a;
    border-bottom: 1px solid #2e5bff1a;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
      padding: 20px;
      box-sizing: border-box;
      overflow-y: auto;

      .el-form {
        .el-form-item {
          margin-bottom: 10px;

          .el-upload-list__item.is-success .el-upload-list__item-status-label {
            display: block;
          }

          .el-upload-list__item:hover {
            .el-icon-upload-success {
              display: none;
            }

            .el-icon-close {
              display: block;
            }
          }

          .el-form-item__label {
            padding: 0;
          }

          .el-form-item__content {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.header-new-drop{
  width: 140px;
  color: red;
  min-height:50px;
  .el-dropdown-menu__item{
    text-align: center;
  }
}
</style>
